import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../service/auth.service';
/**
* check if your subscribtion is NEWS or ALL
*/
@Injectable()
export class NewsGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router,
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {
    const user = this.auth.authToken();
    if (user.subscription === 'ALL' || user.subscription === 'NEWS') {
      return true;
    } else {
      this.router.navigate(['/cockpit/trend/secsignal/stoxx_europe_600_auto_parts_trn']);
    }
  }
}
